import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { getPost } from "@/lib/api";
import { ArrowLeft, Loader2 } from "lucide-react";

export default function BlogDetailPage() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    setLoading(true);
    getPost(slug)
      .then(setPost)
      .catch(() => setError("Post not found."))
      .finally(() => setLoading(false));
  }, [slug]);

  if (loading)
    return (
      <div className="container-app py-32 flex items-center gap-2 text-navy/60">
        <Loader2 className="w-4 h-4 animate-spin" /> Loading…
      </div>
    );

  if (error || !post)
    return (
      <div className="container-app py-32 text-center">
        <h1 className="text-3xl">{error || "Post not found"}</h1>
        <Link to="/insights" className="btn-secondary mt-6 inline-flex">Back to Insights</Link>
      </div>
    );

  return (
    <article className="pb-20" data-testid="blog-detail">
      <div className="relative h-[420px] overflow-hidden">
        <img src={post.cover_image} alt={post.title} className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-navy/70 via-navy/20 to-transparent" />
      </div>
      <div className="container-app -mt-32 relative">
        <div className="bg-white rounded-[2rem] shadow-cardHover p-8 md:p-14 max-w-3xl">
          <Link to="/insights" className="inline-flex items-center gap-2 text-sm text-navy/60 hover:text-navy mb-5">
            <ArrowLeft className="w-4 h-4" /> All Insights
          </Link>
          <span className="text-[10px] uppercase tracking-widest text-gold">{post.category}</span>
          <h1 className="mt-2 text-4xl md:text-5xl leading-tight">{post.title}</h1>
          <div className="mt-3 text-sm text-navy/55">By {post.author}</div>
          <div className="mt-8 text-lg text-navy/80 leading-relaxed whitespace-pre-line">
            {post.body}
          </div>
        </div>
      </div>
    </article>
  );
}
